import React, { useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import { PDFDocument } from 'pdf-lib';
import { Spinner } from 'react-bootstrap';


pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const PdfTextExtractor = () => {
    const [pdfText, setPdfText] = useState('');
    const [splitParams, setSplitParams] = useState([]);
    const [waiting, setWaiting] = useState(false);

    const fichierContainer = useRef();

    const fileInput = useRef(null);
    const premierePageInput = useRef(null);
    const dernierePageInput = useRef(null);

    //const emailRegex = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+/g;
    const declarationRegex = /[A-Z]{4}-[0-9]{2}-[0-9]{7}/g;

    const extract = async () => {
        const file = fileInput.current.files[0];
        const premierePage = parseInt(premierePageInput.current.value);
        const dernierePage = parseInt(dernierePageInput.current.value);
        if (file && premierePage && dernierePage) {
            const fileReader = new FileReader();
            fileReader.onload = async (e) => {
                setPdfText('');
                setWaiting(true);
                const typedArray = new Uint8Array(e.target.result);
                const pdf = await pdfjsLib.getDocument(typedArray).promise;
                let params = [];
                let text = '';
                let debut = -1;
                let declaration = '';
                let i = 0;
                let cpt = 1;
                for (i = premierePage; i <= Math.min(pdf.numPages, dernierePage); i++) {
                    const page = await pdf.getPage(i);
                    const content = await page.getTextContent();
                    const strings = content.items.map(item => item.str);
                    if (strings.indexOf("TANZANIA SINGLE ADMINISTRATIVE DOCUMENT") !== -1) {
                        if (debut !== -1) {
                            text += cpt + " " + declaration + " " + debut + "-" + (i - 1) + "\n";
                            params.push({ declaration: declaration, debut: debut, fin: (i - 1), range: debut + "-" + (i - 1) });
                            cpt++;
                        }

                        if (strings[89].match(declarationRegex)) {
                            declaration = strings[89];
                        }
                        else {
                            for (let s in strings) {
                                if (strings[s].match(declarationRegex)) {
                                    declaration = strings[s];
                                    break;
                                }
                            }
                        }
                        debut = i;
                    }
                    strings.indexOf("TANZANIA SINGLE ADMINISTRATIVE DOCUMENT");
                    //text += strings.join(' ') + ' ';
                }
                if (debut !== -1) {
                    text += declaration + " " + debut + "-" + (i - 1) + "\n";
                    params.push({ declaration: declaration, range: debut + "-" + (i - 1) });
                }
                setWaiting(false);
                setPdfText(text);
                setSplitParams(params);
            };
            fileReader.readAsArrayBuffer(file);
        }
        else alert("Paramètres incomplets");
    };

    const splitByRange = async () => {
        const file = fileInput.current.files[0];
        fichierContainer.current.innerHTML = '';
        if (file) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                setWaiting(true);
                const arrayBuffer = e.target.result;
                const pdfDoc = await PDFDocument.load(arrayBuffer);
                let compte = 1;
                for (const param of splitParams) {
                    const newPdf = await PDFDocument.create();
                    for (let i = param.debut - 1; i < param.fin; i++) {
                        const [copiedPage] = await newPdf.copyPages(pdfDoc, [i]);
                        newPdf.addPage(copiedPage);
                    }
                    const newPdfBytes = await newPdf.save();
                    const blob = new Blob([newPdfBytes], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    // Créer un élément de lien (anchor)
                    const a = document.createElement('a');
                    a.text = param.declaration + ".pdf";
                    a.href = url;
                    a.download = param.declaration + ".pdf";



                    // Ajouter le lien au document et déclencher un clic
                    fichierContainer.current.innerHTML += compte + "&nbsp;";
                    fichierContainer.current.appendChild(a);
                    fichierContainer.current.innerHTML += "<br/>";
                    //document.body.appendChild(a);
                    //a.click();
                    // Retirer le lien du document
                    //document.body.removeChild(a);
                    // Libérer l'URL créée
                    //URL.revokeObjectURL(url);
                    compte++;
                }
                setWaiting(false);
            };
            reader.readAsArrayBuffer(file);
        }
    };

    const download = () => {
        const children = fichierContainer.current.querySelectorAll('a');
        // Parcourir chaque élément et exécuter une action
        children.forEach((child, index) => {
            child.click();
        });
    }

    return (
        <div className='row'>
            <div className='col-lg-5 card card-body'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-8'>
                            <input className='form-control' ref={fileInput} type="file" accept="application/pdf" />
                            <div className='d-flex my-2'>
                                <input className='form-control' type='number' ref={premierePageInput} placeholder='page de début' />
                                <input className='form-control' type='number' ref={dernierePageInput} placeholder='page de fin' />
                            </div>
                            <div>
                                <button className='btn btn-primary' disabled={waiting} onClick={extract}>
                                    {waiting ? <Spinner /> : "Découper"}
                                </button>
                                {splitParams.length > 0 &&
                                    (
                                        <button className='btn btn-danger' disabled={waiting} onClick={splitByRange}>
                                            {waiting ? <Spinner /> : "Télécharger"}
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <textarea value={pdfText} readOnly rows="5" cols="50" />
                        </div>
                    </div>
                </div>
            </div>

            <div className='col-lg-7 card card-body' style={{ maxHeight: '200px' }}>
                <h3>Fichiers&nbsp;{splitParams.length}</h3>
                <button onClick={download}>Télécharger</button>
                <div ref={fichierContainer} />
            </div>
        </div>
    );
};

export default PdfTextExtractor;
